import { render } from "./Procena360.vue?vue&type=template&id=79a69e39&scoped=true&lang=html"
import script from "./Procena360.vue?vue&type=script&lang=js"
export * from "./Procena360.vue?vue&type=script&lang=js"

import "./Procena360.vue?vue&type=style&index=0&id=79a69e39&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-79a69e39"

export default script